import { createSelector } from '@reduxjs/toolkit';
import { normalizeDataIntoApptDates } from '../RxOrders/selectors';

export const getActivePatientsCurrentMedications = createSelector(
  state => state.rxMedications.activePatientRxMedications,
  subState => normalizeDataIntoApptDates(subState),
);

export const getActiveAppointmentCurrentMedications = createSelector(
  state => state.rxMedications.activeAppointmentRxMedications,
  subState => normalizeDataIntoApptDates(subState),
);

export const getActiveMedicinesSelector = createSelector(
  state => state.rxMedications.activeMedicines,
  subState => subState,
);

export const getActiveAllergiesSelector = createSelector(
  state => state.rxMedications.activeAllergies,
  subState => subState.filter(a => a.type === 'Drug'),
);

export const getAddedMedicationsSelector = createSelector(
  state => state.rxMedications.newMedications,
  subState => subState,
);

export const getMedicationStep = createSelector(
  state => state.rxMedications.medicationStep,
  subState => subState,
);
